import { GET_PLACEMENTS, SET_PLACEMENT_SELECTED } from './actions'

const reducer = (state, action) => {
  switch (action.type) {
    case GET_PLACEMENTS:
      state.placements.push(
        ...action.data.map(d => ({
          label: d.name,
          value: d._id,
        }))
      )
      break

    case SET_PLACEMENT_SELECTED:
      state.placementSelected = action.data
      break

    default:
      break
  }
}

export default reducer
